import { endRoute, parentRoute } from '$shared/utils/routes';

export const tantrumRoutes = {
  tantrums: parentRoute('/tantrums')({
    child: endRoute('/tantrums/child'),
    survey: endRoute('/tantrums/survey'),
    feedback: endRoute('/tantrums/feedback'),
  }),
};
